import { Typography, Divider, Box, Button } from "@mui/material";
import NAV from "../../utils/nav.const";
import { StyledLink } from "../PropertyDetails/PropertyDetailsViewing";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

type Props = {
  title: string | null;
  redirectTo?: string;
};

const LoginOrCreateAccount = ({ title, redirectTo }: Props) => {
  const { t } = useTranslation();

  const loginUrl = redirectTo
    ? `/${NAV.SIGNIN}?redirect=${encodeURIComponent(redirectTo)}`
    : `/${NAV.SIGNIN}`;

  const createAccountUrl = redirectTo
    ? `/${NAV.CREATE_TENANT_ACCOUNT}?redirect=${encodeURIComponent(redirectTo)}`
    : `/${NAV.CREATE_TENANT_ACCOUNT}`;

  return (
    <>
      <Typography marginBottom={3}>{title}</Typography>
      <Link to={loginUrl}>
        <Button variant="contained" color="primary" sx={{ width: "100%" }}>
          {t("signin.login")}
        </Button>
      </Link>
      <Divider textAlign="center" sx={{ margin: "10px 0" }}>
        <Typography fontSize={14}>{t("viewing.or")}</Typography>
      </Divider>
      <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
        <StyledLink to={createAccountUrl}>
          {t("viewing.createAccount")}
        </StyledLink>
      </Box>
    </>
  );
};

export default LoginOrCreateAccount;
